import { render, staticRenderFns } from "./EditClassDialog.vue?vue&type=template&id=12047597&scoped=true&"
import script from "./EditClassDialog.vue?vue&type=script&lang=js&"
export * from "./EditClassDialog.vue?vue&type=script&lang=js&"
import style0 from "./EditClassDialog.vue?vue&type=style&index=0&id=12047597&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12047597",
  null
  
)

export default component.exports